import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@mui/material'
import { FC, useCallback } from 'react'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useUpdateTimeClockMutation } from '../../redux/api/timeClockApi'
import { TimeClockEntry } from '../../sdk'

interface Props {
  onClose: () => void
  entry: TimeClockEntry
}

export const DeleteTimeClockDialog: FC<Props> = ({ onClose, entry }) => {
  const { accessToken, userId } = useAccessTokenAndShopId()
  const [updateTimeClock] = useUpdateTimeClockMutation()
  const onDelete = useCallback(() => {
    const now = new Date()
    updateTimeClock({
      authorization: accessToken,
      timeClockEntry: {
        ...entry,
        info: {
          ...entry.info,
          modifiedAt: now,
          modifiedBy: userId,
          archivedAt: now,
          archivedBy: userId
        }
      }
    })
  }, [accessToken, entry, updateTimeClock, userId])
  return (
    <>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this time clock?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={() => {
            onDelete()
            onClose()
          }}>
          Confirm
        </Button>
      </DialogActions>
    </>
  )
}
